import { Component, Input, OnInit } from '@angular/core';
import { GenericListItem } from '../model/list';

@Component({
  selector: 'app-generic-list-item',
  templateUrl: './generic-list-item.component.html',
  styleUrls: ['./generic-list-item.component.css', '../../app.component.scss']
})
export class GenericListItemComponent implements OnInit {

  @Input() data: GenericListItem
  // @Input() userFeedbackService: UserFeedbackService
  // @Output() _delete: EventEmitter<void> = new EventEmitter()
  withoutSub: boolean = true
  constructor() { }

  ngOnInit(): void {
    if (this.data.subTitle) this.withoutSub = false
  }

  click() {
    this.data.onClick()
  }

  delete() {
    this.data.onDelete()
  }

}
